module.exports = __webpack_public_path__ + "static/media/rm_06-35.ee0aec2f.png";